<ng-container *ngIf="label">
    <app-label [label]="label" [cssClass]="'energy-label-'+cssClass.toLowerCase()" [translateContent]="false"></app-label>
</ng-container>